import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const SocialMediaForm = ({ formData, onFormChange, onGenerate, isGenerating }) => {
  const platformOptions = [
    { value: 'twitter', label: 'Twitter/X' },
    { value: 'linkedin', label: 'LinkedIn' },
    { value: 'instagram', label: 'Instagram' },
    { value: 'facebook', label: 'Facebook' }
  ];

  const toneOptions = [
    { value: 'professional', label: 'Professional' },
    { value: 'casual', label: 'Casual' },
    { value: 'enthusiastic', label: 'Enthusiastic' },
    { value: 'informative', label: 'Informative' },
    { value: 'promotional', label: 'Promotional' }
  ];

  const handleInputChange = (field, value) => {
    onFormChange({ ...formData, [field]: value });
  };

  const handlePlatformChange = (platform, checked) => {
    const currentPlatforms = formData?.platforms || [];
    if (checked) {
      handleInputChange('platforms', [...currentPlatforms, platform]);
    } else {
      handleInputChange('platforms', currentPlatforms?.filter(p => p !== platform));
    }
  };

  return (
    <div className="space-y-6">
      <Input
        label="Content Topic"
        type="text"
        placeholder="What do you want to post about?"
        value={formData?.topic || ''}
        onChange={(e) => handleInputChange('topic', e?.target?.value)}
        required
      />
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">
          Content Description
        </label>
        <textarea
          className="w-full h-32 px-3 py-2 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
          placeholder="Describe the content you want to create (book launch, author interview, etc.)"
          value={formData?.description || ''}
          onChange={(e) => handleInputChange('description', e?.target?.value)}
        />
      </div>
      <div className="space-y-3">
        <label className="block text-sm font-medium text-foreground">
          Target Platforms
        </label>
        <div className="grid grid-cols-2 gap-3">
          {platformOptions?.map((platform) => (
            <Checkbox
              key={platform?.value}
              label={platform?.label}
              checked={(formData?.platforms || [])?.includes(platform?.value)}
              onChange={(e) => handlePlatformChange(platform?.value, e?.target?.checked)}
            />
          ))}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Select
          label="Tone"
          options={toneOptions}
          value={formData?.tone || ''}
          onChange={(value) => handleInputChange('tone', value)}
          placeholder="Select tone"
          required
        />
        <Input
          label="Hashtags"
          type="text"
          placeholder="#BookLaunch #NewRelease"
          value={formData?.hashtags || ''}
          onChange={(e) => handleInputChange('hashtags', e?.target?.value)}
        />
      </div>
      <div className="space-y-3">
        <Checkbox
          label="Include Call-to-Action"
          checked={formData?.includeCTA || false}
          onChange={(e) => handleInputChange('includeCTA', e?.target?.checked)}
        />
        <Checkbox
          label="Add Emojis"
          checked={formData?.includeEmojis || false}
          onChange={(e) => handleInputChange('includeEmojis', e?.target?.checked)}
        />
      </div>
      <Button
        onClick={onGenerate}
        loading={isGenerating}
        iconName="Share2"
        iconPosition="left"
        className="w-full"
        disabled={!formData?.topic || !formData?.platforms?.length}
      >
        {isGenerating ? 'Generating Social Posts...' : 'Generate Social Media Content'}
      </Button>
    </div>
  );
};

export default SocialMediaForm;